export default __webpack_public_path__ + "static/media/applechips@2x.43a6c620.jpg";